import React, { useEffect } from 'react';
import { ReactComponent as TickIcon } from 'Assets/svg/tick-icon-new.svg';
import { ReactComponent as InfoIcon } from 'Assets/svg/info-icon.svg';
import { HocPopupComponent } from 'Components/common/hocPopupComponent';
import Button from 'Components/common/Button';
import { Utils } from 'Utils/utils';

const CSVEnrichmentInitiatedPopup = props => {
  const { togglePopup } = props;

  return (
    <HocPopupComponent
      showCloseIcon
      customClassName="csv-enrichment-initiated"
      closeClick={togglePopup}
    >
      <TickIcon className="tick-icon" />
      <div className="popup-title">CSV Enrichment Initiated</div>
      <div className="message">
        Your file is uploaded successfully and the enrichment process has begun.
      </div>
      <section className="note">
        <InfoIcon className="info-icon" />
        <span>
          <span>This will take a few minutes. You will be notified at</span>{' '}
          <span className="highlight">{Utils.getUserEmail()}</span>{' '}
          <span>once the enrichment is complete.</span>
        </span>
      </section>
      <Button
        btnText={
          <>
            Ok <span className="hand-emoji heartBeat">&#128077;</span>
          </>
        }
        click={togglePopup}
      />
    </HocPopupComponent>
  );
};

export default CSVEnrichmentInitiatedPopup;
